import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  license: License;
  organization: Organization;
}

/** ... */

import { ref, computed } from 'vue';

import { faExclamationTriangle } from '@icons/regular/faExclamationTriangle';

import { dateFilter } from '@filters/date';
import { Organization, License } from '@models';
import { dates } from '@utils/dates';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    CardStudentLicenseInfo: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardStudentLicenseInfo' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    license: null,
    organization: null
  },
  setup(__props: any) {

const props = __props as {
  license: License;
  organization: Organization;
};

/** ... */


/** ... */
const icon = ref(faExclamationTriangle);

/** ... */
const expiration = computed(() => props.license.expiration);

/** ... */
const displayExpirationDate = computed(() =>
  expiration.value
    ? (dateFilter(expiration.value, 'MM/dd/yyyy') as string)
    : '--',
);

/** ... */
const daysRemaining = computed(() => {
  if (!expiration.value) return null;

  const currentDateTime = Date.now();

  const value = dates.differenceInDays(expiration.value, currentDateTime);

  return value < 0 ? 0 : value;
});

/** ... */
const hasExpired = computed(() => (daysRemaining.value ?? Infinity) <= 0);

return { __sfc: true,props, icon, expiration, displayExpirationDate, daysRemaining, hasExpired }
}

})